document.addEventListener("click", (event) => {
  // Only run on desktop
  if (window.innerWidth < 749) return;

  const li = event.target.closest("li.product__media-item");
  if (!li) return;

  const gallery = li.closest("[id^='Slider-Gallery-']");
  if (!gallery) return;

  const items = Array.from(gallery.querySelectorAll("li.product__media-item"));
  const clickedIndex = items.indexOf(li);

  if (clickedIndex <= 0) return; // Already primary or invalid

  /* ------------------------------------------
     STOP PREVIOUS MEDIA IF PLAYING
  -------------------------------------------*/
  const currentMedia = gallery.querySelector("li.product__media-item.is-active");

  if (currentMedia) {
    // Pause video
    const deferredVideo = currentMedia.querySelector("deferred-media video");
    if (deferredVideo && !deferredVideo.paused) {
      deferredVideo.pause();
      deferredVideo.currentTime = 0;
    }

    // Pause Shopify 3D Model
    const productModel = currentMedia.querySelector("product-model");
    if (productModel && productModel.modelViewerElement) {
      productModel.modelViewerElement.pause();
    }
  }

  /* ------------------------------------------
     CIRCULAR ROTATION
  -------------------------------------------*/
  const rotated = items.slice(clickedIndex).concat(items.slice(0, clickedIndex));

  rotated.forEach(item => gallery.appendChild(item));

  /* ------------------------------------------
     UPDATE ACTIVE CLASS
  -------------------------------------------*/
  items.forEach(item => item.classList.remove("is-active"));
  rotated[0].classList.add("is-active");

  /* ------------------------------------------
     RESET DEFERRED-MEDIA ON NEW ACTIVE ITEM
     So "Play" button returns and loadContent()
     runs like Shopify wants.
  -------------------------------------------*/
  const active = items[0];
  const deferred = active.querySelector("deferred-media");

  if (deferred) {
    // Remove loaded="true" so loadContent() triggers again
    deferred.removeAttribute("loaded");

    // Remove previously inserted media (video, iframe, model-viewer)
    const alreadyLoaded = deferred.querySelector("video, model-viewer, iframe");
    if (alreadyLoaded) alreadyLoaded.remove();

    // Restore poster/play-button if missing
    if (!deferred.querySelector(".deferred-media__poster")) {
      const tpl = deferred.querySelector("template[slot='poster']");
      let posterBtn;

      if (tpl) {
        // Clone play button from Dawn's template
        posterBtn = tpl.content.firstElementChild.cloneNode(true);
      } else {
        // Fallback simple play button
        posterBtn = document.createElement("button");
        posterBtn.className = "deferred-media__poster";
        posterBtn.innerHTML = `
          <svg aria-hidden="true" focusable="false" width="48" height="48" style="pointer-events:none">
            <polygon points="0,0 48,24 0,48"></polygon>
          </svg>
        `;
      }

      deferred.insertBefore(posterBtn, deferred.firstChild);
    }
  }

  /* ------------------------------------------
     SCROLL INTO VIEW
  -------------------------------------------*/
  rotated[0].scrollIntoView({
    behavior: "smooth",
    block: "nearest",
    inline: "center"
  });
});
